import React, { useRef } from "react";
import {
  Modal,
  Button,
  Accordion,
  Form,
  OverlayTrigger,
  Tooltip,
  Card,
} from "react-bootstrap";
import { useState, useEffect } from "react";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../features/RadConnStyle";

import { CreateTooltip, FormatThaiCard, XButton } from "../../core/Helper";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../features/UserActions";
import styled from "styled-components";
import {
  AiOutlinePaperClip,
  AiFillSave,
  AiOutlineDelete,
  AiFillPrinter,
  AiOutlineVerticalAlignBottom,
  AiFillCloseCircle,
  AiOutlineAudit,
} from "react-icons/ai";
import {
  FcDecision,
  FcMultipleDevices,
  FcPicture,
  FcReadingEbook,
} from "react-icons/fc";
import {
  FormControlBlack,
  FormSelectBlack,
  LabelBlack,
  LabelBlackSimpleText,
} from "../components/PageParams";
import StudyHistories from "./StudyHistories";
// import RichTextEditor from "../../components/RichTextEditor";
import StudyItems from "./StudyItems";
import { BsPen } from "react-icons/bs";
import TemplateEditorSaveAs from "./TemplateEditorSaveAs";
import { HiPlus } from "react-icons/hi";
import { GiAnatomy, GiZipper } from "react-icons/gi";
import { MdAttachFile } from "react-icons/md";
import ConfirmDialogB from "../components/ConfirmDialogB";
import PopupReportStateOption from "./PopupReportStateOption";
import PopupOpenRemoteFile from "./PopupOpenRemoteFile";
import PopupReportPdf from "./PopupReportPdf";
import XrayImage from "../../images/x-ray.png";
import DownloadProgressPop from "./DownloadProgressPop";
import RadiComment from "./Z01-RadiComment";

import RadioResultPastCheck from "./RadioResultPastCheck";
import { StudyService } from "../../model/study";
import { StudyTemplateService } from "../../model/study-template";
import { Oval } from "react-loading-icons";
import { CustomerService } from "../../model/customer";
import { FaDownload, FaFolderOpen } from "react-icons/fa";
import { GrDocumentZip } from "react-icons/gr";
import { RCXDicomLauncher, TokenService } from "../../model/token";
import RcxDownload from "./RcxDownload";
import { StudyReportService } from "../../model/study-report";
function RadioResult(props) {
  const { userDetail } = props;
  const [editor, setEditor] = props.editor;
  const [showCtx, setShowCtx] = props.showCtx;
  const [selectedRow, setSelectedRow] = props.selectedRow;

  const dispatch = useDispatch();
  const [dataX, setDataX] = useState(null);
  const [showImage, setShowImage] = props.showImage;
  const [updateFlag, setUpdateFlag] = props.updateFlag;

  const [templateEditor, setTemplateEditor] = useState({ show: false });
  const [templList, setTempList] = useState([]);

  const [confirm, setConfirm] = useState({ show: false, action: () => {} });

  const [templateId, setTemplateId] = useState(-1);
  const [repcheck, setRepCheck] = useState(1);
  const [priceData, setPriceData] = useState([]);
  const [fullScreen, setFullScreen] = useState(false);
  //const [printFrm, setPrintFrm] = useState({ show: false, action: () => {} });

  const [reportStateOption, setReportStateOption] = useState({ show: false });
  const [fileOpener, setFileOpener] = useState({ show: false });

  // pdf renderer
  const [winPdfState, setWinPdfState] = useState({ show: false });
  const [saveCompleteAction, setSaveCompleteAction] = useState(false);

  const uploadType = { FILE: 1, CAPTURED: 2 };
  const editRef = useRef(null); // Ref for Editor

  const [loading, setLoading] = props.loading;
  const [loading2, setLoading2] = useState(false);
  const [enablePreview, setEnaPreview] = useState(false);

  const [studySubItem, setSubItem] = useState(null);
  const [showOld, setShowOld] = useState({ show: false, action: () => {} });

  /** File Download States */

  const [dwProgress, setDwlProgress] = useState(0);
  const [dwShow, setDwShow] = useState(false);
  const [dwText, setDwText] = useState("");
  const [dlgState, setDlgState] = useState({ show: false, callback: () => {} });

  const [radiComment, setRadiComment] = useState({
    show: false,
    action: () => {},
  });

  /** First use effect */

  useEffect(() => {
    if (editor?.show === true) {
      //*enable double click to select text
      //*effected event at 'App.js'
      document.dispatchEvent(
        new CustomEvent("mouse_event_update", { detail: { action: true } }),
      );

      getInfo(() => setLoading(false));
      // return () => {
      //   //* disable selection text
      //   document.dispatchEvent(
      //     new CustomEvent("mouse_event_update", { detail: { action: false } })
      //   );

      //   setSaveCompleteAction(false);
      //   // setDataX(null);
      // };
    }

    // if (editor.action != null) {
    //   getInfo(() => {
    //     editor.action();
    //   });
    // }

    return () => {
      //* disable selection text
      document.dispatchEvent(
        new CustomEvent("mouse_event_update", { detail: { action: false } }),
      );

      setSaveCompleteAction(false);
      setWinPdfState({ show: false });

      //******* set last-result-len == 0 to reset  timer ""*/
      setResuLen(-1);
    };
  }, [editor]);

  useEffect(() => {
    if (!editor?.show) return;

    if (dataX && dataX.priceItems) {
      setPriceData(dataX?.priceItems);
      refreshTemplate();
      if (dataX && dataX?.studyResult.length > 0) {
        editRef.current.value =
          dataX?.studyResult.length > 0 && dataX?.studyResult[0]?.result_text;

        let ret = (dataX?.studyResult[0]?.result_text ?? "").replace(
          /\s*/g,
          "",
        );
        //**** รับค่าความยาวของผล */
        setResuLen(ret?.length ?? 0);

        /** saveCompleateAction === showReport */

        if (
          dataX.studyResult &&
          saveCompleteAction === true &&
          dataX.studyResult.length > 0
        ) {
          // setWinPdfState({
          //   show:
          //     saveCompleteAction && dataX.studyResult[0].result_type_id >= 2,
          //   action: () => {
          //     setUpdateFlag(true);
          //     setEditor((pv) => ({ ...pv, show: false }));
          //     setSaveCompleteAction(false);
          //   },
          // });
        }
      } else {
        editRef.current.value = "";
        setResuLen(0);
      }
    }
    return () => {
      setSaveCompleteAction(false);
    };
  }, [dataX]);

  //----------------------------------------------------------------------
  // หลังจากปรับปรุงรายการ template แล้ว ให้แสดงรายการแรกขึ้นมา กรณีไม่ใช่การแก้ไขผล
  useEffect(() => {
    if (templList.length > 0) {
      setTemplateId(templList[0].templ_id);
    }
  }, [templList]);

  /*  แสดงข้อมูลคนไข้  */
  const getInfo = async (callback) => {
    if (selectedRow == null) return;
    let tmp = await StudyService.GetRadioInfoWithHistory({
      StudyInfo: { ...selectedRow },
      UserInfo: userDetail,
    });

    if (tmp != null) {
      setDataX({
        studyInfo: {
          ...tmp?.StudyInfo[0],
          patients_idcard:
            tmp &&
            tmp?.StudyInfo[0]?.patients_idcard &&
            FormatThaiCard(tmp?.StudyInfo[0]?.patients_idcard),
        },
        attachedFile: tmp?.StudyFileAttached,
        priceItems: tmp?.PriceItems,
        studyResult: tmp?.StudyResults,
        studyHistory: tmp?.StudyHistory,
      });

      setRepCheck(
        tmp.StudyResults && tmp.StudyResults.length > 0
          ? tmp.StudyResults[0].result_type_id
          : 1,
      );
    } else {
      dispatch(
        setReminder({ show: true, message: "ไม่พบข้อมูล", type: "error" }),
      );
    }
    callback();
  };

  /* REFRESH TEMPLATE  */
  const refreshTemplate = async () => {
    let goodList = "";
    if (dataX && dataX.priceItems.length > 0) {
      dataX.priceItems.map((r) => {
        goodList += r.goodid + ",";
      });

      if (goodList.length > 0) {
        goodList = goodList.substring(0, goodList.length - 1);
      }
    }

    // * เรียก และ แสดงรายการ Template ทั้งหมด
    if (editor.show === true) {
      let ret = await StudyTemplateService.GetTemplateList({
        UserInfo: userDetail,
        GoodInfo: goodList,
        StudyInfo: dataX.studyInfo,
      });

      if (ret != null) {
        if (ret.rows) {
          setTempList(ret.rows);
        } else {
          setTempList([]);
        }
      } else {
        dispatch(
          setReminder({
            show: true,
            message: "ไม่พบรายการ Template",
            type: "error",
          }),
        );
      }
    }

    setDefaultTemplateEditor();
  };

  useEffect(() => {
    if (saveCompleteAction) {
      // setWinPdfState({
      //   show: saveCompleteAction && dataX.studyResult[0].result_type_id >= 2,
      //   action: () => {
      setUpdateFlag(true);
      setEditor((pv) => ({ ...pv, show: false }));
      setSaveCompleteAction(false);
      //  },
      // });
    }
  }, [saveCompleteAction]);

  const setDefaultTemplateEditor = () => {
    setTemplateEditor({ show: false, action: () => {} });
  };

  //----------------------------------------------------------------------
  //
  const saveData = async (resultState, actionSave) => {
    const oResult = editRef.current.value;
    setLoading(true);

    let ret = await StudyService.UpdateStudyResult({
      UserInfo: userDetail,
      StudyInfo: selectedRow,
      ReportInfo: { reptype: resultState },
      ResultText: oResult,
    });

    // เอา approve ผลมาวางตรงนี้แทน ขั้นตอนการ Approve อีกรอบ
    if (resultState > 1) {
      ret = await StudyReportService.ApproveAReport({
        userInfo: userDetail,
        studyInfo: selectedRow,
      });
    }

    if (ret != null) {
      setLoading(false);
      getInfo(actionSave);
    } else {
      setLoading(false);
      dispatch(
        setReminder({
          show: true,
          message: "ไม่สามารถบันทึกผลได้",
          type: "error",
        }),
      );
    }
  };

  /*** -------------------- Show Image ------------------------------ */
  const imageButtonClick = (item) => {
    setShowImage({
      show: true,
      imagePath: process.env.REACT_APP_API + "/" + item.image_path,
      imageName: item.image_name,
    });
  };

  //**  Open linked file from upload complete! */
  const openLink = (item) => {
    let url = process.env.REACT_APP_API + "/" + item.image_path;
    window.open(url, "_blank", "noreferrer");
  };

  const showTemplateEditor = (type) => {
    if (editRef.current.value.trim() === "") {
      dispatch(
        setReminder({
          show: true,
          message:
            "ไม่มีข้อความบน Tempate ต้นฉบับ \n กรุณากรอกข้อความบนเอกสารเพือนำไปใช้เป็นต้นแบบ",
          type: "error",
        }),
      );
      return;
    }

    if (type === "new") {
      setTemplateEditor({
        show: true,
        templ_id: -1,
        action: () => {
          refreshTemplate();
        },
      });
    } else {
      if (templateId === 0) {
        dispatch(
          setReminder({
            show: true,
            message: "ยังไม่ได้เลือก Template",
            type: "error",
          }),
        );
        return;
      }
      setTemplateEditor({
        show: true,
        templ_id: templateId,
        action: () => {
          refreshTemplate();
        },
      });
    }
  };

  // เมื่อมีการเลือก Template ใหม่
  const selectedTemplateChanged = (e) => {
    setTemplateId(e.target.value);
  };

  const showCurrentTempate = () => {
    getReportTemplateDetail();
  };

  // เรียก และ แสงรายละเอียด Template จากรายการที่เลือก
  const getReportTemplateDetail = async () => {
    if (!templateId) return;

    let ret = await StudyService.GetReportTemplateDetail({
      UserInfo: userDetail,
      ItemInfo: { templ_id: templateId },
    });

    if (ret != null) {
      editRef.current.value += "\n" + ret.TemplateDetail[0].templ_text;
    } else {
      dispatch(
        setReminder({
          show: true,
          message: "ไม่พบข้อมูล",
          type: "error",
        }),
      );
    }
  };

  const RemoveTemplate = async () => {
    if (templateId === 0) {
      dispatch(
        setReminder({
          show: true,
          message: "กรุณาเลือก Template ที่ต้องการลบ",
          type: "error",
        }),
      );
      return;
    }

    let ret = await StudyTemplateService.RemoveTemplate({
      UserInfo: userDetail,
      TemplateInfo: { templ_id: templateId },
    });
    if (ret != null) {
      dispatch(
        setReminder({ show: true, message: "ยกเลิกสมบูรณ์", type: "success" }),
      );
      refreshTemplate();
    } else {
      dispatch(
        setReminder({
          show: true,
          message: "ไม่พบรายการ",
          type: "error",
        }),
      );
    }
  };

  const handleClose = () => {
    if (dwProgress !== 0) {
      dispatch(
        setReminder({
          show: true,
          message: "กรุณารอสักครู่ เพื่อ Download เสร็จ",
          type: "error",
        }),
      );
      return;
    }
    setEditor((pv) => ({ ...pv, show: false }));
  };

  const setCommentShow = () => {
    setRadiComment({
      show: true,
      action: (data) => {},
    });
  };

  // Auto Saving Data  *************************
  // -------------------------------------------

  const [restLen, setResuLen] = useState(-1);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (restLen > -1) {
      const timeoutId = setInterval(() => {
        let lastRet = editRef.current?.value?.replace(/\s*/g, "").length ?? 1;

        if (lastRet !== restLen) {
          //console.log(new Date().toLocaleString(), "Autosave start ....");
          autoSave();
          setResuLen(lastRet);
        }
      }, 60 * 1000);

      return () => {
        // when restlen = 0
        clearInterval(timeoutId);
        //console.log("Timer for chack character size ended..");
      };
    }
  }, [restLen]);

  //**** Auto Saving Report */
  const autoSave = async () => {
    // console.log("autosave... start");
    const oResult = editRef.current?.value;
    const resultId = dataX?.studyResult[0]?.std_result_id ?? -1;
    setSaving(true);
    let ret = await StudyService.UpdateStudyResultAutoDraft({
      UserInfo: userDetail,
      StudyInfo: selectedRow,
      ReportInfo: { resultId: resultId },
      ResultText: oResult,
    });
    if (ret) {
      //console.log("auto-saved");
    }
    setSaving(false);
  };
  const resultKeyDown = (e) => {
    // let a = e.target.value.replace(/\s*/g, "");
    // console.log(restLen, a.length);
  };

  const theme = useSelector((s) => s.theme.theme);

  const openUrl = async (e) => {
    e.preventDefault();

    // ** get token
    setLoading2(true);
    let info = await TokenService.GetToken(null, userDetail);
    var a = document.createElement("a");
    a.href = "rcx-dicom://?token=" + (info?.token ?? "");
    document.body.appendChild(a);
    a.click();

    // const launcher = new RCXDicomLauncher(userDetail);
    // launcher.launchDicomOpener();
    setTimeout(() => {
      // ถ้าหน้าต่างยังคงเป็น focus อยู่ แสดงว่าโปรแกรมอาจไม่เปิด
      if (document.hasFocus()) {
        console.log("still focus .....");
        // this.showInstallPrompt();
        setDlgState((pv) => ({ ...pv, show: true }));
      }
      setLoading2(false);
    }, 3000);
  };

  /*** -------------------------------------------------- */
  return (
    <MyModal
      style={{ background: theme?.themeName === "light" ? "white" : "#252627" }}
      show={editor.show}
      size="xl"
      backdrop={false}
    >
      <ModalHeaderBlack
        closeButton
        style={{ maxHeight: "50px" }}
        onHide={() => handleClose()}
      >
        <FcReadingEbook
          style={{
            color: "var(--fore-primary)",
            fontSize: "30px",
            margin: "0 5px 0 5px",
          }}
        />
        บันทึกผลวินิจฉัย{props.formName}
      </ModalHeaderBlack>

      <ModalBodyBlack
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        {/* {loading ? <Loading /> : <></>} */}
        <div
          style={{
            flex: "1",
            // maxWidth: "1070px",
          }}
        >
          <HBox>
            <LabelBlack style={{ maxWidth: "90px", borderRadius: "0" }}>
              ชือ-สกุล
            </LabelBlack>
            <LabelBlackSimpleText style={{ flex: "1", borderRadius: "0" }}>
              {dataX && dataX.studyInfo?.patients_name}
            </LabelBlackSimpleText>
            <LabelBlack style={{ maxWidth: "50px", borderRadius: "0" }}>
              เพศ
            </LabelBlack>
            <LabelBlackSimpleText style={{ flex: "1", maxWidth: "60px" }}>
              {dataX && dataX.studyInfo?.patients_sex == "M" ? "ชาย" : "หญิง"}
            </LabelBlackSimpleText>
            <LabelBlack style={{ maxWidth: "50px", borderRadius: "0" }}>
              อายุ
            </LabelBlack>
            <LabelBlackSimpleText style={{ flex: "1", maxWidth: "80px" }}>
              {dataX &&
                dataX?.studyInfo?.patients_age
                  .replace(/^0+/g, "")
                  .replace(/[y,Y]/g, " ปี")
                  .replace(/[m,M]/, " เดือน")}
            </LabelBlackSimpleText>
            <LabelBlack style={{ maxWidth: "50px", borderRadius: "0" }}>
              HN
            </LabelBlack>
            <LabelBlackSimpleText style={{ flex: "1", maxWidth: "120px" }}>
              {dataX && dataX.studyInfo?.patientid}
            </LabelBlackSimpleText>
          </HBox>

          {/* According */}
          <Accordion defaultActiveKey={["0", "1", "2"]} alwaysOpen>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <GiAnatomy style={Styles.buttonImage} />
                ส่วนที่ตรวจ-DF
              </Accordion.Header>
              <Accordion.Body style={Styles.accordionBody}>
                <VBox
                  style={{
                    width: "100%",
                    height: "150px",
                    overflowY: "scroll",
                  }}
                >
                  <HBox>
                    <StudyItems {...{ priceData: [priceData, setPriceData] }} />
                  </HBox>
                </VBox>
              </Accordion.Body>
            </Accordion.Item>

            {/* ------------------------- ITEM 2  */}
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <img
                  src={XrayImage}
                  alt=""
                  style={{
                    width: "40px",
                    marginInline: "10px",
                  }}
                />
                ประวัติการตรวจทั้งหมด
              </Accordion.Header>

              <Accordion.Body style={Styles.accordionBody}>
                <VBox
                  style={{
                    width: "100%",
                    height: "150px",
                    overflowY: "scroll",
                  }}
                >
                  <DivHistoryStyle>
                    <div></div>
                    <DivHistoryStyleBtn>
                      {CreateTooltip(
                        "เปิดเครื่องมือค้นหาไฟล์ Zip",
                        <XButton
                          style={{ marginBlock: "5px" }}
                          onMouseUp={(e) => openUrl(e)}
                        >
                          {loading2 ? (
                            <Oval
                              height={20}
                              width={20}
                              style={{ marginInlineEnd: "10px" }}
                            />
                          ) : (
                            <FaFolderOpen
                              size={20}
                              color="var(--icon-fore)"
                              style={Styles.iconButton}
                            />
                          )}
                          เครื่องมือช่วยค้นหา Zip ไฟล์
                        </XButton>,
                      )}
                    </DivHistoryStyleBtn>
                  </DivHistoryStyle>

                  <HBox>
                    {/* Check at StudyHistory for download operation */}

                    <StudyHistories
                      {...{
                        data: [dataX, setDataX],
                        editor: [editor, setEditor],
                        userDetail: userDetail,
                        winState: [fileOpener, setFileOpener, setLoading],
                        selectedItem: [studySubItem, setSubItem],
                        showOldParam: [showOld, setShowOld],
                        dwState: [
                          dwProgress,
                          setDwlProgress,
                          dwShow,
                          setDwShow,
                          dwText,
                          setDwText,
                        ],
                      }}
                    />
                  </HBox>
                </VBox>
              </Accordion.Body>
            </Accordion.Item>

            {/* ------------------------- ITEM 2  */}
            <Accordion.Item eventKey="2">
              {/* header */}
              <Accordion.Header>
                <MdAttachFile
                  style={{ ...Styles.buttonImage, ...{ height: "30px" } }}
                />{" "}
                ไฟล์แนบ - หมายเหตุ - อื่นๆ
              </Accordion.Header>

              <Accordion.Body style={Styles.accordionBody}>
                <VBox
                  style={{
                    width: "100%",
                    height: "150px",
                    overflowY: "scroll",
                  }}
                >
                  {/* List of attached files .. */}
                  <HBox>
                    <FileListBox>
                      {dataX &&
                        dataX.attachedFile &&
                        dataX.attachedFile.map((item, i) => {
                          switch (item.upload_type) {
                            case uploadType.FILE: //1
                              return (
                                <ImageLinkButton
                                  key={i}
                                  onClick={() => openLink(item)}
                                >
                                  <AiOutlinePaperClip
                                    style={styles.fileAttachIcon}
                                  />
                                  {`${item.image_name}`}
                                </ImageLinkButton>
                              );
                            case uploadType.CAPTURED: //2
                              return (
                                <ImageLinkButton
                                  key={i}
                                  onClick={() => openLink(item)}
                                >
                                  <FcPicture style={styles.fileAttachIcon} />
                                  {`${item.image_name}`}
                                </ImageLinkButton>
                              );
                            default:
                              return (
                                <ImageLinkButton
                                  key={i}
                                  onClick={() => openLink(item)}
                                />
                              );
                          }
                        })}
                    </FileListBox>
                  </HBox>

                  {/* หมายเหตุ  */}
                  {dataX && dataX.studyInfo ? (
                    <div
                      style={{
                        display: "flex",
                        color: "var(--fore-primary)",
                        flexDirection: "column",
                        marginInline: "5px",
                        flex: "1",
                      }}
                    >
                      <div
                        style={{
                          paddingLeft: "15px",
                          borderBottom: "solid 1px var(--bg-primary)",
                        }}
                      >
                        หมายเหตุ:
                      </div>
                      <FormControlBlack
                        readOnly
                        as="textarea"
                        style={{ flex: "1", paddingLeft: "15px" }}
                        // rows={5}
                        value={dataX.studyInfo?.study_remark}
                      ></FormControlBlack>
                    </div>
                  ) : (
                    <></>
                  )}
                </VBox>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          <HBox
            style={{
              background: "var( --bg-accordian-on)",
              display: props.enableSave ? "flex" : "none",
              // border: "1px solid #899974",
              margin: "0px",
              padding: "5px",
              // borderRadius: "5px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <AiOutlineAudit
              style={{ color: "var(--fore-primary)", fontSize: "20px" }}
            />
            <LabelBlack
              style={{
                flex: "1",
                maxWidth: "100px",
                marginRight: "1px",
                backgroundColor: "transparent",
                color: "var(--fore-accordian-on)",
              }}
            >
              Template:
            </LabelBlack>

            <FormSelectBlack
              style={{
                color: "var(--select-item-color)",
                flex: "1",
                marginRight: "5px",
              }}
              aria-label="ตัวเลือก"
              rows={templList}
              onChange={selectedTemplateChanged}
              name={"goodCateId"}
            />

            <OverlayTrigger
              placement="top"
              overlay={(props) => (
                <Tooltip {...props}>Suffixs this template</Tooltip>
              )}
            >
              <Button
                style={Styles.buttonTemplate}
                onClick={() => showCurrentTempate()}
              >
                {" "}
                <AiOutlineVerticalAlignBottom />
              </Button>
            </OverlayTrigger>

            <OverlayTrigger
              placement="top"
              overlay={(props) => (
                <Tooltip {...props}>Save all content to a new template</Tooltip>
              )}
            >
              <Button
                style={Styles.buttonTemplate}
                onClick={() => showTemplateEditor("new")}
              >
                {" "}
                <HiPlus />
              </Button>
            </OverlayTrigger>

            <OverlayTrigger
              placement="top"
              overlay={(props) => (
                <Tooltip {...props}>Edit selected template</Tooltip>
              )}
            >
              <Button
                style={Styles.buttonTemplate}
                onClick={() => showTemplateEditor("edit")}
              >
                {" "}
                <BsPen />
              </Button>
            </OverlayTrigger>

            <OverlayTrigger
              placement="top"
              overlay={(props) => (
                <Tooltip {...props}>Delete selected template</Tooltip>
              )}
            >
              <Button
                variant="danger"
                style={Styles.buttonTemplate}
                onClick={() =>
                  setConfirm({
                    show: true,
                    title: "กรุณายืนยันการลบ Template ", //GetConfirmTitle("DELETE"),
                    action: (e) => {
                      if (e === true) {
                        RemoveTemplate();
                      }
                    },
                  })
                }
              >
                <AiOutlineDelete />
              </Button>
            </OverlayTrigger>
          </HBox>

          <HBox></HBox>

          <div
            style={{
              background: "white",
              marginLeft: "auto",
              marginRight: "auto",
              marginTop: "5px",
              borderRadius: "2px",
              boxShadow: "5px 5px 10px 0px var(--bg-primary)",
            }}
          >
            {saving ? (
              <DivAutoSave>
                <Oval height={20} stroke="var(--icon-fore)" />
                <span>Auto Saving ...</span>
              </DivAutoSave>
            ) : (
              <></>
            )}
            <Form.Control
              style={{
                fontFamily: "Times New Roman",
                background: "var(--bg-primary)",
                color: "var(--fore-primary)",
              }}
              as="textarea"
              rows={24}
              ref={editRef}
              // onChange={onResultChanged}
              onKeyDown={resultKeyDown}
            ></Form.Control>
          </div>
        </div>
      </ModalBodyBlack>

      <ModalFooterBlack style={{ justifyContent: "center" }}>
        <div
          style={{
            display: "flex",
            flex: "1",
            justifyContent: "space-between",
            // maxWidth: "1070px",
            margin: "0 0 0 -10px",
          }}
        >
          <div>
            <Button
              style={{ marginInline: "2px" }}
              variant="warning"
              // disabled
              onClick={setCommentShow}
            >
              <FcDecision style={Styles.buttonImage} />
              แจ้งปัญหา
            </Button>

            <Button
              style={{ marginInline: "2px" }}
              variant="secondary"
              disabled
            >
              <FcMultipleDevices style={Styles.buttonImage} />
              สร้าง Conferrence เพื่อปรึกษา
            </Button>
          </div>

          <div>
            {/* Save Button */}
            <Button
              // variant={theme.themeName}
              style={{
                marginInline: "2px",
                display: props.enableSave ? "inline" : "none",
                width: "200px",
              }}
              onClick={() => {
                setRepCheck(3);
                // แสดงตัวเลือกประเภทการผล {}
                setReportStateOption({
                  show: true,

                  // ** callback  เมื่อมีการยืนยันผลจากแพทย์
                  action: (e) => {
                    if (e && e.confirm) {
                      saveData(e.resultType, () => {
                        /** ตั้งค่าสถานะการบันทึกสมบูรณ์  xxx */
                        // ** เจ้านายให้เอาออกก่อนครับ
                        setSaveCompleteAction(true);
                        if (e.resultType > 1) {
                          // previewPdf();
                        } else {
                          setUpdateFlag(true);
                          setEditor((pv) => ({ ...pv, show: false }));
                        }
                      });
                    }
                  },
                });
              }}
            >
              <AiFillSave style={{ ...Styles.buttonImage }} />
              บันทึก
            </Button>

            {/* Preview Button */}
            {enablePreview ? (
              <Button
                style={{
                  marginInline: "2px",
                  // display: props.enablePrint ? "inline" : "none",
                }}
                variant="info"
                onClick={() => {
                  //previewPdf();
                }}
              >
                {" "}
                <AiFillPrinter style={Styles.buttonImage} />
                Preview
              </Button>
            ) : (
              <></>
            )}

            {/* Close Button */}

            <Button
              variant="danger"
              style={{ marginLeft: "2px" }}
              onClick={() => {
                setEditor((pv) => ({ ...pv, show: false }));
              }}
            >
              <AiFillCloseCircle style={Styles.buttonImage} />
              ปิด
            </Button>
          </div>
        </div>
      </ModalFooterBlack>

      <TemplateEditorSaveAs
        {...{
          winState: [
            templateEditor,
            setTemplateEditor,
            editRef,
            priceData,
            setPriceData,
          ],
        }}
      />

      <ConfirmDialogB {...{ winState: [confirm, setConfirm] }} />

      <PopupReportStateOption
        {...{
          winState: [
            reportStateOption,
            setReportStateOption,
            repcheck,
            setRepCheck,
            props.enableSave,
            dataX,
          ],
        }}
      />
      <PopupOpenRemoteFile
        {...{ userDetail, winState: [fileOpener, setFileOpener, dataX] }}
      />
      <PopupReportPdf
        {...{
          winState: [winPdfState, setWinPdfState],
          data: dataX,
          userInfo: userDetail,
          loading: [loading, setLoading],
        }}
      />

      <DownloadProgressPop
        {...{
          options: [
            dwProgress,
            setDwlProgress,
            dwShow,
            setDwShow,
            dwText,
            setDwText,
          ],
        }}
      />

      {/* <PrintDocu {... {winState:[printFrm, setPrintFrm], ...editRef}} /> */}
      <RadiComment
        {...{ radiComment: [radiComment, setRadiComment], dataX: [dataX] }}
      />

      <RadioResultPastCheck
        {...{
          userDetail: userDetail,
          selectedItem: [studySubItem, setSubItem],
          showParam: [showOld, setShowOld],
        }}
      />

      <RcxDownload {...{ dlgState: [dlgState, setDlgState] }} />
    </MyModal>
  );
}

const HBox = styled.div`
  display: flex;
  flex: 1;
`;

const VBox = styled.div``;

const FileListBox = styled.p`
  padding: 10px 1px 10px 5px;
  color: white;
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  justify-content: "space-between";
`;

const ImageLinkButton = styled.div`
  text-decoration: none;
  /* color: #bebbbe; */
  color: var(--fore-primary);
  cursor: pointer;
  padding: 2px;
  margin: 1px 5px 1px 5px;
  transition: 100ms;
  font-size: 13px;
  word-break: break-word; // break-all;
  :hover {
    transition: 2s;
    text-decoration: none;
    /* color: #08e75e; */
    color: var(--fore-primary);
  }
`;

const Styles = {
  accordionBody: { background: "var(--bg-primary)", padding: "0 0 0 0px" },
  buttonTemplate: { marginRight: "5px" },
  buttonImage: {
    // marginInline: "10px",
    marginTop: "5px",
    marginBottom: "5px",
    // color: "#f7f2f2",
    color: "var(--icon-fore)",
    height: "30px",
    width: "40px",
  },
  buttonImageBig: {
    marginRight: "5px",
    // color: "#121212",
    color: "var(--bg-primary)",
    height: "40px",
    width: "40px",
  },
  iconButton: { marginInlineEnd: "5px" },
  innerIconButton: { marginTop: "-5px" },
};

const styles = {
  fileAttachIcon: {
    // color: "#96e307",
    color: "var(--fore-primary)",
    marginInline: "5px",
  },
};

const DivAutoSave = styled.div`
  position: absolute;
  right: 0px;
  height: 150;
  width: 300;
  color: var(--fore-primary);
  padding-inline: 20px;
  padding-block: 5px;
  opacity: 0.5;
  /* background: red; */
`;

/** กรอบสำหรับวางปุ่ม เครื่องมือช่วยค้นหา zip ไฟล์ */
const DivHistoryStyle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-inline: 5px;
`;

const DivHistoryStyleBtn = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export default React.memo(RadioResult);
